export default "__VITE_ASSET__74a460c3__"